import { api } from '@/services'

export function findAllDevolusPendingActions(params) {
  return api.get('admin/devolusPendingAction/search', { params })
}

export function findByIdDevolusPendingActions(id) {
  return api.get(`admin/devolusPendingAction/details/${id}`)
}

export function resolveDevolusPendingAction(id) {
  return api.post(`admin/devolusPendingAction/solve/${id}`)
}
